var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(" ")]),_c('td',{staticStyle:{"border-right":"2px solid #000"},attrs:{"colspan":"16"}}),_c('td',{attrs:{"colspan":"5"}})])
}]

export { render, staticRenderFns }